import React, {useState, useEffect, useMemo, useContext} from "react";
import { useForm } from "react-hook-form";
import {Link, useLocation, useParams} from "react-router-dom";
import moment from 'moment';
import {Backdrop, Grid, ListItem} from "@material-ui/core";
import {MUIDataTableColumnDef, MUISortOptions} from "mui-datatables";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  StrOption,
  apollo_useStyles, Option, options_clicktoaction,
  options_reviewstatus_for_view,
  options_state_edit,
  options_zeus_pmp_type,
  option_zeus_adtype,
  valueToOption, valueToOptionNull,
  ZEUS_DELIVERY_TYPE_STRING,
  ZEUS_DELIVERY_TYPE_STRING_SHORT,
  options_display_parent_archive_ads,
} from "../../../atom/Apollo_styles_Beta";
import {
  options_select_all,
} from "../../../atom/Apollo_Options";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth, APOLLO_PROFILE_SYSTEM_ADMIN, IsAuthorization} from "../../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {
  advertisementedit_path,
  get_zeus_ads_performance_path,
  get_zeus_resources_images_path,
  get_zeus_ads,
  patch_zeus_ads_path,
  apollo_setpoints_path,
} from "../../../atom/Apollo_links";
import {ApolloRightDrawerContext, RightDrawer} from "../../../molecule/Apollo_RightDrawer";
import {
  ApolloBasicSelect,
} from "../../../molecule/Apollo_BaseItem";
import {ApolloDateRangePicker} from "../../../atom/Apollo_DateRangePicker";
import ApolloPerformance from "../../../molecule/Apollo_Performance";
import {
  createApolloCsvBlob,
  formatApolloCsvCell,
  formatApolloCsvCellArray,
  toUtcIso8601str,
  valueToLabel,
  mergeOptions,
} from "../../../common/Apollo_CommonUtil_Beta";
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";
import {LintChartColumnsPtn, LintChartStorageKey} from "../../SUMMARY/LineChart_Beta";
import {
  generateCsvHeader,
  generateSetPointColumns,
  generateColumns,
} from "../../SUMMARY/IndividualSummary";
import {DataTableOptions, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {Bars} from "react-loader-spinner";
import {
  AdvertisementZeusColumns,
  CsvData,
  UNDER_SCORE,
  ALL,
  MSG,
  RESULT_SETPOINT_ERROR,
  TRACKING_POINT,
} from "../../../common/Apollo_CommonConst_Beta";
import AdvertisementEditZeus from "./AdvertisementEditZeus";
import {
  AdAsset,
  AdDescription,
  AdImage,
  AdTag,
  AdTitle,
  AdWithPerformanceZeus,
  ChartRawDataZeus
} from "./AdvertisementModelZeus";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import Switch from '@material-ui/core/Switch';
import InputLabel from "@material-ui/core/InputLabel";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloEventRecord, LogData, ItemList} from "../../../atom/Apollo_EventRecord";
import {AdvertisementZeus, Asset, InputAsset, LogRecord, ResAsset} from "./AdvertisementModelZeus";
import {cloneDeep} from "lodash";
import {ROW_PER_PAGE_OPTIONS} from "../../../common/Apollo_CommonConst";
import {
  APOLLO_PAGE_ID,
  applyApolloSharedColumnSettings,
  createApolloSharedTableOptions,
  getApolloSharedCalendar,
  saveApolloSharedCalendar,
} from "../../../common/Apollo_LocalStorageSettings";

const ApolloPerformanceMemo = React.memo(ApolloPerformance);

const DATE_TIME_SUFFIX = "Z"
const BLANK = ""

// 画面名：広告一覧（Zeus）
const AdvertisementPageZeus: React.FC = () => {
  const classes = apollo_useStyles();
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {accountgroupid, accountid, platformaccountid} = useParams();
  const {state} = useContext(ApolloContext);
  const displayParentArchiveFilterValue: number[] = state.filterInfo.displayParentArchiveFilterValue;
  const [tableData, setTableData] = useState<AdWithPerformanceZeus[]>([]);
  const [chartRawData, setChartRawData] = useState<ChartRawDataZeus[]>([]);
  const [reflectAt, setReflectAt] = useState<string>("")
  const [advertisementId, setAdvertisementId] = useState<number>(0);
  const isAuthorization = IsAuthorization(APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN);
          
  const MIN_START_DATE = moment("2025-10-01");
  const DEFAULT_END_DATE = moment("2025-10-31");
  const LIMIT_DATE = moment("2025-09-30");

  // 条件判定
  const isBeforeLimit = moment().isSameOrBefore(LIMIT_DATE, "day");

  const defaultStartDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(MIN_START_DATE)
    : toUtcIso8601str(moment().startOf("month"));
  const defaultEndDate = !isAuthorization && isBeforeLimit
    ? toUtcIso8601str(DEFAULT_END_DATE)
    : toUtcIso8601str(moment().endOf("month"));
  const initialCalendar = getApolloSharedCalendar({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  const [startDate, setStartDate] = useState(initialCalendar.startDate);
  const [endDate, setEndDate] = useState(initialCalendar.endDate);
  const [previousStartDate, setPreviousStartDate] = useState(toUtcIso8601str(moment().startOf('month')))
  const [previousEndDate, setPreviousEndDate] = useState(toUtcIso8601str(moment().endOf('month')))
  const [previousChartRawData, setPreviousChartRawData] = useState<ChartRawDataZeus[]>([])
  const [isPreviousPeriodChecked, setIsPreviousPeriodChecked]= useState<boolean>(false)
  const [isPreviousPeriodDisabled, setIsPreviousPeriodDisabled]= useState<boolean>(false)
  const [isChartDataLoaded, setIsChartDataLoaded] = useState(false);
  const [selectedValues, setSelectedValues] = useState<string[]>([ALL]);
  const [optionImages, setOptionImages] = useState<Option[]>([]);
  const [setPoints, setSetPoints] = useState<Option[]>([]);
  const [deletedSetPoints, setDeletedSetPoints] = useState<Option[]>([]);
  const [isSetPointsLoaded, setIsSetPointsLoaded] = useState(false);
  // ステータストグル押下フラグ
  const [isPushStatusToggle, setIsPushStatusToggle] = useState<boolean>(false);

  // 期間変更比較
  type BeforeStartEndDate = {
    startDate: string,
    endDate: string,
  }
  const currentBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  const previousBeforeDate = React.useRef<BeforeStartEndDate>({
    startDate: "",
    endDate: "",
  });
  // useForm
  const {
    control,
    errors,
  } = useForm({reValidateMode: 'onBlur'});

  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = reqParams.get("campaignId") ?? "0";
  const adGroupId = reqParams.get("adGroupId") ?? "0";
  const queryCampaignId = campaignId !== "0" ? `?campaignId=${campaignId}` : "";
  const queryAdGroupId = queryCampaignId !== "" ?
    adGroupId !== "0" ? `${queryCampaignId}&adGroupId=${adGroupId}` : `?campaignId=${campaignId}` :
    adGroupId !== "0" ? `?adGroupId=${adGroupId}` : "";
  const [updateListCnt, setUpdateListCnt] = useState<number>(0);
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 25,
    breadId: 1,
    queries: ["", "", "", "", queryCampaignId],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const initEditAd: AdWithPerformanceZeus = {
    id: 0,
    createdAt: "",
    updatedAt: "",
    lastUpdateUserId: "",
    adAccountId: 0,
    adCampaignId: 0,
    adGroupId: 0,
    name: "",
    campaignType: "",
    pmpType: 1,
    pmpTypeLabel: "",
    adType: 1,
    status: 0,
    displayParentArchiveCode: 0,
    link: "",
    customUrl: "",
    sponsor: "",
    cta: 0,
    sponsorDomain: "",
    titles: [],
    descriptions: [],
    images: [],
    videos: [],
    apps: [],
    mails: [],
    tags: [],
    adAccountName: "",
    adCampaignName: "",
    adGroupName: "",
    reviewStatus: 0,
    reviewStatusForView: 0,
    cost: 0,
    imp: 0,
    click: 0,
    ctr: 0,
    cpc: 0,
    cpm: 0,
    trackingPointCvTotal: 0,
    trackingPointCvClickThrough: 0,
    trackingPointCvAssist: 0,
    trackingPointCpaTotal: 0,
    trackingPointCpaClickThrough: 0,
    trackingPointCpaAssist: 0,
    trackingPointCvrTotal: 0,
    trackingPointCvrClickThrough: 0,
    trackingPointCvrAssist: 0,
    lastCvTotal: 0,
    lastCpaTotal: 0,
    lastCvrTotal: 0,
    trackingPointCvClickThroughSetPoints: [],
    trackingPointCvAssistSetPoints: [],
    trackingPointCpaClickThroughSetPoints: [],
    trackingPointCvrClickThroughSetPoints: [],
  }

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "id",
    direction: 'desc',
  })

  const [columnFilterForStatus, setColumnFilterForStatus] = useState(options_state_edit.filter(elem => elem.value !== 3).map(elem => elem.label))
  const [columnFilterForDisplayParentArchive, setColumnFilterForDisplayParentArchive] = useState(
    options_display_parent_archive_ads.filter(elem => (displayParentArchiveFilterValue??[]).includes(elem.value)).map(elem => elem.label)
  )

  const listReloadFunc = () => {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setUpdateListCnt(updateListCnt + 1)
  };

  useEffect(() => {
    if (!isSetPointsLoaded && !isPushStatusToggle) return;

    setIsChartDataLoaded(false);
    const start = moment(startDate);
    const end = moment(endDate);
    const diffDays = end.diff(start, 'days') + 1;
    const previousStart = start.subtract(diffDays, 'days').format('YYYY-MM-DD');
    const previousEnd = end.subtract(diffDays, 'days').format('YYYY-MM-DD');
    setPreviousStartDate(previousStart);
    setPreviousEndDate(previousEnd);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    });

    const fetchImages = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !advertisementId) return;
      const url = `${get_zeus_resources_images_path}?account_id=${platformaccountid}&per_page=9999&page=1&sort=created&direction=desc`
      await ApolloAxios.get(url).then(response => {
        if (response.status !== 200) {
          return Promise.reject({
            open: true,
            type: getResultType(response.status === 400 ? -1 : -9),
            errmsg: "広告画像情報を取得できませんでした",
          });
        }

        // TODO: APIレスポンスをApollo2.0用に整形後、受け取り処理を修正
        // const res: ApiResponse = response.data;
        // if (!isSuccessApi(res.resultCode)) {
        //   return Promise.reject({
        //     open: true,
        //     type: getResultType(res.resultCode),
        //     errmsg: res?.message ? res.message : "オーディエンス情報を取得できませんでした",
        //   });
        // }

        const newImages: Option[] = [];
        response.data?.map(function (data: { id: number, url: string }) {
          const option: Option = {
            value: data.id,
            label: data.url,
          }
          newImages.push(option);
        });
        setOptionImages(newImages);

      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      })
    }

    const fetchAds = async () => {
      if (startDate === currentBeforeDate.current.startDate && endDate === currentBeforeDate.current.endDate && !isPushStatusToggle && !advertisementId) return;
      setProgress(true);
      let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads_performance_path}?account_id=${platformaccountid}&startDateTime=${startDate}&endDateTime=${endDate}&per_page=9999&page=1&sort=created&direction=desc`
      const query = queryAdGroupId !== "" ? queryAdGroupId.replace("campaignId", "campaign_id").replace("adGroupId", "group_id").replace("?", "&") : "";
      await ApolloAxios.get(`${url}${query}`).then(response => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          return Promise.reject({
            open: true,
            type: getResultType(res.resultCode),
            errmsg: res?.message ? res.message : "広告情報の取得に失敗しました",
          });
        }
        let localTableData: AdWithPerformanceZeus[] = res.result.list
        setTableData(localTableData?.map(elem => {
          let pmpTypeLabel = valueToLabel(elem.pmpType, options_zeus_pmp_type)
          if (elem.campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE) {
            pmpTypeLabel = "-"
          }

          const retElem: AdWithPerformanceZeus = {
            ...elem,
            pmpTypeLabel: pmpTypeLabel,
          };
          return retElem;
        }));

        if (res.result.chartData) setChartRawData(res.result.chartData);
        if (res.result.reflectAt) setReflectAt(res.result.reflectAt);
        currentBeforeDate.current = {startDate: startDate, endDate: endDate,}
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      }).finally(() => {
        setProgress(false);
      });
    }

    const fetchPreviousAds = async () => {
      if (!isPreviousPeriodChecked && !isPushStatusToggle) return;
      if (startDate === previousBeforeDate.current.startDate && endDate === previousBeforeDate.current.endDate && !isPushStatusToggle) return;
      setIsPreviousPeriodDisabled(true);
      let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads_performance_path}?account_id=${platformaccountid}&startDateTime=${previousStart}&endDateTime=${previousEnd}&per_page=9999&page=1&sort=created&direction=desc`
      const query = queryAdGroupId !== "" ? queryAdGroupId.replace("campaignId", "campaign_id").replace("adGroupId", "group_id").replace("?", "&") : "";
      await ApolloAxios.get(`${url}${query}`).then(response => {
        const res: ApiResponse = response.data;
        if (!isSuccessApi(res.resultCode)) {
          return Promise.reject({
            open: true,
            type: getResultType(res.resultCode),
            errmsg: res?.message ? res.message : "広告情報の取得に失敗しました",
          });
        }
        if (res.result.chartData) setPreviousChartRawData(res.result.chartData);
        previousBeforeDate.current = {startDate: startDate, endDate: endDate,}
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: err.type,
            message: err.errmsg,
          }
        });
      }).finally(() => {
        setIsPreviousPeriodDisabled(false);
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchImages(), fetchAds(), fetchPreviousAds()]
      ).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsPushStatusToggle(false);
        setProgress(false);
        setIsChartDataLoaded(true);
      });
    }
    fetchAll();

  }, [startDate, endDate, updateListCnt, isSetPointsLoaded, isPreviousPeriodChecked]);

  useEffect(() => {
    const fetchSetPoints = () => {
      const url = `${process.env.REACT_APP_API_ENDPOINT}${apollo_setpoints_path}/${accountid}`;
      ApolloAxios.get(url).then((response) => {
        if (response.data?.resultCode === RESULT_SETPOINT_ERROR) {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: `${MSG.ERROR_GET_SET_POINTS}${response?.data?.message ?? BLANK}`
            }
          });
        } else if (response.data.result) {
          const newSetPoints: Option[] = [];
          const newDeletedSetPoints: Option[] = [];
          response.data?.result?.map(function (data: { setPointId: number, setPointName: string, setPointDeleteFlg: number }) {
            if (data.setPointDeleteFlg === 0) {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}`,
              }
              newSetPoints.push(option);
            } else {
              const option: Option = {
                value: data.setPointId,
                label: `${data.setPointId}${UNDER_SCORE}${data.setPointName}（削除済み）`,
              }
              newDeletedSetPoints.push(option);
            }
          });
          setSetPoints(newSetPoints);
          setDeletedSetPoints(newDeletedSetPoints);
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `${MSG.ERROR_GET_SET_POINTS}${err?.errmsg ?? BLANK}`
          }
        });
      }).finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
        setIsSetPointsLoaded(true);
      });
    }

    const fetchAll = async () => {
      await Promise.all(
        [fetchSetPoints()]
      ).finally(() => {
      })
    }

    fetchAll();

  }, []);

  const createOptions = () => {
    var local_options = [...options_select_all];

    if (tableData && tableData.length > 0) {
      tableData.forEach((data, index) => {
        var opt: StrOption = {
          value: `${index}`,
          label: `${data.id}${UNDER_SCORE}${data.name}`,
        }
        local_options.push(opt);
      });
    }

    return local_options;
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <Tooltip title="広告編集" placement="bottom">
              <IconButton
                size="small"
                color="primary"
                aria-label="edit"
                disabled={tableData[idx].adType === 6}
                onClick={() => {
                  editIconClick(idx)
                }}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
          );
        }
      },
    },
    {
      name: "id",
      label: "広告ID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
      },
    },
    {
      name: "name",
      label: "広告名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },
    {
      name: "adGroupName",
      label: "広告グループ名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },
    {
      name: "adCampaignName",
      label: "キャンペーン名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },
    {
      name: "campaignType",
      label: "キャンペーン種別",
      options: {
        filter: true,
        sort: false,
        setCellProps: () => ({style: {minWidth: "9rem"}}),
        customBodyRender: (value: string) => {
          let background: string = "black"
          switch (true) {
            case value === "Performance":
              background = "#373c38";
              break;
            case value === "コネパスDSP":
              background = "#6e75a4";
              break;
            default:
              break;
          }
          return (
            <Chip
              label={
                <Typography variant="subtitle1">
                  {value}
                </Typography>
              }
              style={
                {backgroundColor: background, color: 'white', height: "100%"}
              }
            />
          )
        }
      },
    },
    {
      name: "pmpTypeLabel",
      label: "取引形式",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
      },
    },    {
      name: "adType",
      label: "広告種別",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        customBodyRender: (value: number) => {
          return valueToOption(value, option_zeus_adtype).label
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "trigger",
        display: !IsAuthorization(APOLLO_GROUP_OPERATOR, APOLLO_SYSTEM_ADMIN)
          ? 'excluded'
          : true,
        setCellProps: () => ({style: {minWidth: "8rem", textAlign: "center"}}),
        customBodyRenderLite: (idx: number) => {
          const status = tableData[idx].status
          if (status === 3) return ("");
          return (
            <Switch
              checked={status === 1 ? true : false}
              onChange={(event, checked) => handleStatusChange(checked, tableData[idx])}
              disabled={tableData[idx].adType === 6}
              color="primary"
            ></Switch>
          );
        }
      } as any,
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        filterList: columnFilterForStatus,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => valueToOption(value, options_state_edit).label,
      },
    },
    {
      name: "displayParentArchive",
      label: "親キャンペーン・親広告グループのステータス",
      options: {
        filter: true,
        filterList: columnFilterForDisplayParentArchive,
        display: false,
        viewColumns: false,
        customBodyRender: (value: number) => valueToOption(value, options_display_parent_archive_ads).label,
      },
    },
    {
      name: "reviewStatusForView",
      label: "審査ステータス",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "10rem"}}),
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_reviewstatus_for_view).label
        },
        customFilterListOptions: {
          render: (value: number) => valueToOption(value, options_reviewstatus_for_view).label
        },
        customBodyRenderLite: (idx: number) => {
          const value = tableData[idx];
          return (
            <React.Fragment>
              {
                valueToOption(value.reviewStatusForView, options_reviewstatus_for_view)?.label
              }
            </React.Fragment>
          );
        },
      },
    },
    {
      name: "images",
      label: "広告アセット情報",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({style: {minWidth: "10rem", position: "relative", textAlign: "center"}}),
        customBodyRender: (values: AdImage[], tableMeta) => {
          const rowId = tableMeta.rowData[1]; // columnsで"広告ID"が2番目なので[1]
          const row = tableData.find((r) => r.id === rowId);
          if (!row) return ""; // 念のため存在チェック
          if (row.adType === 6) {
            return "";
          }

          const urlList: string[] = [];
          values?.map((image: AdImage) => {
            const option = valueToOptionNull(image.adAccountImageResourceId, optionImages);
            if (option) urlList.push(option.label);
          });
          if (urlList.length === 0) return "-";
          if (urlList.length === 1) return (
            <img src={urlList[0]} alt="" style={{maxHeight: "80px"}}/>
          );
          return (
            <React.Fragment>
              <ListItem>
                {urlList?.map((url: string, idx: number) => (
                  <img src={url} alt="" width="100" height="60"
                       style={{position: "absolute", zIndex: 3 - idx, marginLeft: `${0 + idx}rem`, marginBottom: `${0 + idx}rem`}}/>
                ))}
              </ListItem>
            </React.Fragment>
          )
        }
      }
    },
    {
      name: "",
      label: " ",
      options: {
        filter: false,
        sort: false,
        apolloColumnId: "adAssetInfoBlank",
        setCellProps: () => ({style: {minWidth: "20rem"}}),
        customBodyRenderLite: (idx: number) => {
          const value = tableData[idx];
          const asset: AdAsset = {
            titles: [],
            descriptions: [],
            sponsor: value.sponsor && value.sponsor !== "" ? value.sponsor : "",
            cta: value.cta && value.cta !== 0 ? valueToOption(value.cta, options_clicktoaction)?.label : "",
            link: value.link && value.link !== "" ? value.link : "",
            sponsorDomain: value.sponsorDomain && value.sponsorDomain !== "" ? value.sponsorDomain : "",
          }
          value.titles?.map((title) => {
            asset.titles.push(title.text);
          });
          if (asset.titles.length === 0) {
            asset.titles.push("");
          }
          value.descriptions?.map((description) => {
            asset.descriptions.push(description.text);
          });
          if (asset.descriptions.length === 0) {
            asset.descriptions.push("");
          }

          return (
            <React.Fragment>
              <Grid container spacing={3} style={{marginLeft: 10, padding: "12px 32px 12px 6px", maxWidth: "50rem"}}>
                {asset.titles.length > 0 &&
                <Grid item xs={12} style={{
                  fontSize: 16,
                  padding: 6,
                  minHeight: 34
                }}>{asset.titles.length === 1 ? asset.titles[0] : `${asset.titles[0]} 他`}</Grid>
                }
                {asset.descriptions.length > 0 &&
                <Grid item xs={12} style={{
                  fontSize: 14,
                  padding: 6,
                  minHeight: 32
                }}>{asset.descriptions.length === 1 ? asset.descriptions[0] : `${asset.descriptions[0]} 他`}</Grid>
                }
                <Grid item xs={12} style={{fontSize: 12, padding: 6, minHeight: 29}}>{asset.sponsor}</Grid>
                <Grid item xs={12} style={{fontSize: 12, padding: 6, minHeight: 29}}>{asset.cta}</Grid>
                <Grid item xs={12} style={{fontSize: 12, padding: 6, minHeight: 29}}>
                  <a style={{wordWrap: "break-word"}} href={asset.link}>{asset.link}</a>
                </Grid>
                <Grid item xs={12} style={{fontSize: 12, padding: 6, minHeight: 29}}>{asset.sponsorDomain}</Grid>
              </Grid>
            </React.Fragment>
          )
        }
      } as any,
    },
    {
      name: "cost",
      label: "cost",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "imp",
      label: "imp",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "click",
      label: "click",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "ctr",
      label: "CTR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "cpc",
      label: "平均CPC",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "cpm",
      label: "CPM",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCvTotal",
      label: "CV(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvClickThrough",
      label: "ラストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvAssist",
      label: "アシストクリックCV(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "trackingPointCvrTotal",
      label: "CVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrClickThrough",
      label: "ラストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCvrAssist",
      label: "アシストクリックCVR(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "trackingPointCpaTotal",
      label: "CPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCpaClickThrough",
      label: "ラストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "trackingPointCpaAssist",
      label: "アシストクリックCPA(合計)",
      options: {
        filter: false,
        sort: true,
        display: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : false,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => `¥${value?.toLocaleString()}`,
      }
    },
    {
      name: "lastCvTotal",
      label: "最適化ポイントCV",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => value?.toLocaleString(),
      }
    },
    {
      name: "lastCvrTotal",
      label: "最適化ポイントCVR",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => (Math.floor((Math.round(value * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2) + "%",
      }
    },
    {
      name: "lastCpaTotal",
      label: "最適化ポイントCPA",
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({style: {minWidth: "8rem"}}),
        customBodyRender: (value: number) => "¥" + value?.toLocaleString(),
      }
    },
  ];

  // function
  const editIconClick = (index: number) => {
    setAdvertisementId(tableData[index].id);
    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    })
  }

  // 表で使用するパラメータをMemo化
  const chartRawDataMemo =  useMemo(() => chartRawData.map(value => value.performances), [selectedValues, chartRawData, previousChartRawData]);
  const previousChartRawDataMemo =  useMemo(() => previousChartRawData.map(value => value.performances), [selectedValues, chartRawData, previousChartRawData]);
  const columnsMemo =  useMemo(() => applyApolloSharedColumnSettings(
    generateColumns(columns, STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST, setPoints, deletedSetPoints),
    {pageId: APOLLO_PAGE_ID.AD_ZEUS, accountGroupId: accountgroupid, data: tableData}
  ), [tableData, drawerState, columnFilterForStatus, columnFilterForDisplayParentArchive, optionImages, setPoints, deletedSetPoints, accountgroupid]);
  const setpointMemo =  useMemo(() => mergeOptions(setPoints, deletedSetPoints), [setPoints, deletedSetPoints]);
  const titleMemo = useMemo(() =>
    <React.Fragment>
      <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <Tooltip title="広告新規作成" placement="bottom">
          <Link
            to={`${advertisementedit_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}&adGroupId=${adGroupId}`}>
            <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
              <AddIcon/>
            </Fab>
          </Link>
        </Tooltip>
      </ApolloUserProfileAuth>
      <p style={{fontSize: "15px"}}>
        {
          "実績値取得日時: " +
          (
            reflectAt
              ? moment(reflectAt.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
                : BLANK
          )
        }
      </p>
      <p style={{fontSize: "15px", color: "red"}}>
        ※Performance Networkにおいて、ドコモ媒体以外の一般メディアの広告の審査結果は審査ステータスに反映されておりません
      </p>
    </React.Fragment>, [reflectAt])

  const optionsMemo : DataTableOptions = useMemo(() => createApolloSharedTableOptions(
    {
      print: false,
      downloadOptions: {
        filename: ``,
        separator: ",",
        filterOptions: {
          useDisplayedColumnsOnly: false,
          useDisplayedRowsOnly: true,
        }
      },
      onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
        const fileName = `advertisements_performance_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`;
        const csvData = formatCsvData(data, tableData, optionImages, setPoints, deletedSetPoints);
        const blob = createApolloCsvBlob(generateCsvHeader(AdvertisementZeusColumns, setPoints, deletedSetPoints), csvData);
        const link = document.createElement("a");
        link.setAttribute("href", window.URL.createObjectURL(blob));
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        return false;
      },
      elevation: 0,
      sortOrder: localStorage.getItem(STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST) ? undefined : sortOrder,
      selectToolbarPlacement: "above",
      filterType: "multiselect",
      storageKey: STORAGE_KEY.ZEUS_ADVERTISEMENTS_LIST,
      jumpToPage: true,
      rowsPerPageOptions: ROW_PER_PAGE_OPTIONS.HOME_AND_MAIN_LEVELS,
      customToolbarSelect: () => undefined,
      onFilterChange: (changedColumn, filterList, type, changedColumnIndex) => {
        if (changedColumn === "status") {
          setColumnFilterForStatus(filterList[changedColumnIndex]);
        } else if (changedColumn === "displayParentArchive") {
          setColumnFilterForDisplayParentArchive(filterList[changedColumnIndex]);
        }
      },
      onColumnSortChange: (changedColumn: string, direction: string) => {
        setSortOrder({
          name: changedColumn,
          direction: direction,
        } as MUISortOptions)
      },
    },
    {
      pageId: APOLLO_PAGE_ID.AD_ZEUS,
      accountGroupId: accountgroupid,
      columns: columnsMemo,
    }
  ), [tableData, setPoints, deletedSetPoints, columnsMemo, accountgroupid])

  useEffect(() => {
    saveApolloSharedCalendar(startDate, endDate);
  }, [startDate, endDate]);

  const adInfo = React.useRef<AdWithPerformanceZeus>(initEditAd);
  const newStatusInfo = React.useRef(-1);
  const resultApi = React.useRef(-1);

  const handleStatusChange = async(checked: boolean, row: AdWithPerformanceZeus) => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })

    let isError = false;
    let advertisementZeus: AdvertisementZeus = {
      id: 0,
      createdAt: "",
      updatedAt: "",
      lastUpdateUserId: "",
      adAccountId: 0,
      adCampaignId: 0,
      adGroupId: 0,
      name: "",
      adType: 1,
      status: 2,
      link: "",
      customUrl: "",
      sponsor: "",
      cta: 1,
      sponsorDomain: "",
      titles: [],
      descriptions: [],
      images: [],
      videos: [],
      tags: [],
      apps: [],
      mails: [],
      adAccountName: "",
      adCampaignName: "",
      adGroupName: "",
      reviewStatus: 0,
      reviewReason: 0,
      reviewStatusForView: 0,
    }

    const getUrl = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ads}/${row.id}`
    await ApolloAxios.get(getUrl).then(response => {
      const res = response.data;
      if (response.status !== 200) {
        isError = true;
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "広告情報の取得に失敗しました",
        });
      }

      advertisementZeus = {
        ...cloneDeep(response.data)
      }
    }).catch(err => {
      isError = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    if (isError) {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
      return;
    };

    const newStatus = checked ? 1 : 2

    // 操作ログ出力(編集)
    adInfo.current = row;
    newStatusInfo.current = newStatus;
    resultApi.current = 0;
    writeLog();

    const patchUrl = `${process.env.REACT_APP_API_ENDPOINT}${patch_zeus_ads_path}/${row.id}`
    const body = {
      ...cloneDeep(advertisementZeus),
      status: newStatus,
    }
    await ApolloAxios.patch(patchUrl, body).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        // 操作ログ(失敗)
        resultApi.current = 9;
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : "ステータス更新に失敗しました。",
        });
      }
      // 操作ログ(成功)
      resultApi.current = 1;
    }).catch(err => {
      // 操作ログ(失敗)
      resultApi.current = 9;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    });

    // 操作ログ出力(結果)
    writeLog();

    if (resultApi.current === 1) {
      setIsPushStatusToggle(true);
      setUpdateListCnt(updateListCnt + 1)
    } else {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: false
        }
      })
      setProgress(false);
    }
  }

  /** 操作ログ出力 */
  const writeLog = () => {
    if (resultApi.current < 0) return;

    const itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(adInfo.current.status, options_state_edit).label + "",
        afterValue: valueToOption(newStatusInfo.current, options_state_edit).label + "",
      },
    ]

    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: resultApi.current === 0 ? "execute" : "result",
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: adInfo.current.adCampaignId + "",
      campaignName: adInfo.current.adCampaignName + "",
      adGroupID: adInfo.current.adGroupId + "",
      adGroupName: adInfo.current.adGroupName + "",
      menu: "パフォーマンス広告",
      displayName: "広告一覧画面",
      category: "広告",
      actionType: "更新",
      targetID: adInfo.current.id + "",
      targetName: adInfo.current.name + "",
      itemList: itemList,
    }

    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  const [progress, setProgress] = useState(true);
  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <CustomizedSnackbars/>
      <Grid container spacing={1} justify="flex-end">
        <Grid item xs={4} md={4} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <ApolloDateRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            {...(!isAuthorization && { startMinDate: new Date("2025-10-01T00:00:00") })}
          />
        </Grid>

        <Grid item xs={4} md={4}>
          <InputLabel id="graph-display-select">
            <Typography variant="caption">
            グラフ表示対象の選択
            </Typography>
          </InputLabel>
          <div>
            <ApolloBasicSelect
              id={"graph-display-select"}
              label=""
              isMulti={true}
              options={createOptions()}
              value={selectedValues}
              control={control}
              errors={errors}
              closeMenuOnSelect={false}
              setState={(e: any) => {
                const setVals = !e || e[e.length - 1].value === ALL ? [ALL] : e.filter((target: any) =>
                  target.value !== ALL
                ).map((target: any) => target.value);
                setSelectedValues(setVals)
              }}
              selectStyle={{maxHeight: "70px", overflowY: "scroll" }}
            />
          </div>
        </Grid>

        <Grid item xs={4} md={4}>
        </Grid>
      </Grid>
      <ApolloPerformanceMemo
        startDate={startDate}
        endDate={endDate}
        previousStartDate={previousStartDate}
        previousEndDate={previousEndDate}
        dailyPerformanceData={chartRawDataMemo}
        previousDailyPerformanceData={previousChartRawDataMemo}
        selectedValues={selectedValues}
        data={tableData}
        columns={columnsMemo}
        options={optionsMemo}
        chartPtn={LintChartColumnsPtn.Ptn3}
        storageKeyGraph1={LintChartStorageKey.ZeusAdvertisementGraph1}
        storageKeyGraph2={LintChartStorageKey.ZeusAdvertisementGraph2}
        fileName={`chart_advertisements_performance_${moment(startDate).format("YYYYMMDD")}_${moment(endDate).format("YYYYMMDD")}.csv`}
        isPreviousPeriodChecked={isPreviousPeriodChecked}
        setIsPreviousPeriodChecked={setIsPreviousPeriodChecked}
        isPreviousPeriodDisabled={isPreviousPeriodDisabled}
        isChartDataLoaded={isChartDataLoaded}
        setPoints={setpointMemo}
        title={titleMemo}
      />
      <RightDrawer>
        <AdvertisementEditZeus
          platformAccountId={platformaccountid}
          advertisementId={advertisementId}
          listReloadFunc={listReloadFunc}
        />
      </RightDrawer>
    </GenericTemplate>
  );
};

const formatCsvData = (data: any[], tableData: AdWithPerformanceZeus[], optionImages: Option[], setPoints: Option[], deletedSetPoints: Option[]): CsvData[] => {
  const dataList: CsvData[] = [];
  let mergedSetPoints = [...setPoints, ...deletedSetPoints];
  data?.map((v: { index: any, data: any[] }) => {
      if (!v.data || v.data.length === 0) return;
      const values = tableData.filter((td) => td.id === v.data[1]);
      if (!values || values.length === 0) return;
      const d = values[0];

      let campaignType = d.campaignType;
      if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.PERFORMANCE;
      } else if (campaignType === ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP) {
        campaignType = ZEUS_DELIVERY_TYPE_STRING.DSP;
      }

      let pmpTypeStr = valueToLabel(d.pmpType, options_zeus_pmp_type)
      if (campaignType === ZEUS_DELIVERY_TYPE_STRING.PERFORMANCE) {
        pmpTypeStr = "-"
      }

      const assetList = [
        {id: "", url: ""},
        {id: "", url: ""},
      ];
      const asset: AdAsset = {
        titles: ["", "", ""],
        descriptions: ["", "", ""],
        sponsor: d.sponsor,
        cta: d.cta ? valueToOption(d.cta, options_clicktoaction)?.label : "",
        link: d.link,
        sponsorDomain: d.sponsorDomain ?? "",
      };

      if (d.adType===6) {
        d.tags?.map((tags: AdTag, idx: number) => {
          assetList[idx] = {id: String(tags.adAccountTagResourceId), url: ""}
      });
      } else {
        d.images?.map((image: AdImage, idx: number) => {
          const option = valueToOptionNull(image.adAccountImageResourceId, optionImages);
          if (option) {
            assetList[idx] = {id: option.value?.toString(), url: option.label}
          }
        });
      }

      d.titles?.map((title: AdTitle, idx: number) => {
        asset.titles[idx] = title.text;
      });

      d.descriptions?.map((description: AdDescription, idx: number) => {
        asset.descriptions[idx] = description.text;
      });

      const list: CsvData = {
        index: v.index,
        data: [
          formatApolloCsvCell(d.id),
          formatApolloCsvCell(d.name, true),
          formatApolloCsvCell(d.adGroupName, true),
          formatApolloCsvCell(d.adCampaignName, true),
          formatApolloCsvCell(campaignType),
          formatApolloCsvCell(pmpTypeStr),
          formatApolloCsvCell(valueToLabel(d.adType, option_zeus_adtype)),
          formatApolloCsvCell(valueToLabel(d.status, options_state_edit)),
          formatApolloCsvCell(valueToLabel(d.reviewStatusForView, options_reviewstatus_for_view)),
          formatApolloCsvCell(assetList[0].id, ),
          formatApolloCsvCell(assetList[0].url, true),
          formatApolloCsvCell(assetList[1].id, ),
          formatApolloCsvCell(assetList[1].url, true),
          formatApolloCsvCell(asset.titles[0], true),
          formatApolloCsvCell(asset.titles[1], true),
          formatApolloCsvCell(asset.titles[2], true),
          formatApolloCsvCell(asset.descriptions[0], true),
          formatApolloCsvCell(asset.descriptions[1], true),
          formatApolloCsvCell(asset.descriptions[2], true),
          formatApolloCsvCell(asset.sponsor, true),
          formatApolloCsvCell(asset.cta),
          formatApolloCsvCell(asset.link, true),
          formatApolloCsvCell(asset.sponsorDomain),
          formatApolloCsvCell(`￥${d.cost}`),
          formatApolloCsvCell(d.imp),
          formatApolloCsvCell(d.click),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.ctr * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.cpc}`),
          formatApolloCsvCell(`￥${d.cpm}`),
          formatApolloCsvCell(d.trackingPointCvTotal),
          formatApolloCsvCell(d.trackingPointCvClickThrough),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvClickThroughSetPoints, TRACKING_POINT.CV_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(d.trackingPointCvAssist),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvAssistSetPoints, TRACKING_POINT.CV_ASSIST, mergedSetPoints)),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrClickThrough * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCvrClickThroughSetPoints, TRACKING_POINT.CVR_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.trackingPointCvrAssist * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.trackingPointCpaTotal}`),
          formatApolloCsvCell(`￥${d.trackingPointCpaClickThrough}`),
          ...formatApolloCsvCellArray(generateSetPointColumns(d.trackingPointCpaClickThroughSetPoints, TRACKING_POINT.CPA_CLICK_THROUGH, mergedSetPoints)),
          formatApolloCsvCell(`￥${d.trackingPointCpaAssist}`),
          formatApolloCsvCell(d.lastCvTotal),
          formatApolloCsvCell(`${(Math.floor((Math.round(d.lastCvrTotal * 1000000) / 1000000) * 100 * 100) / 100).toFixed(2)}%`),
          formatApolloCsvCell(`￥${d.lastCpaTotal}`),
        ],
      };
      dataList.push(list);
    }
  );
  return dataList;
}

export default AdvertisementPageZeus;
